import logo from "../assets/Done-logo.svg";
import { useAuth } from "../contexts/AuthContext";

export default function Header() {
  const { user, isDemoMode, logout } = useAuth();

  return (
    <header className="py-6 flex items-center justify-between px-4 max-w-6xl mx-auto">
      <div className="flex items-center gap-2">
        <h1 className="text-white text-3xl font-bold">Nexo</h1>
        <img src={logo} alt="Logo" className="w-10 h-10" />
      </div>

      <div className="flex items-center gap-4">
        {isDemoMode ? (
          <span className="text-amber-500 font-semibold bg-amber-500/10 px-3 py-1 rounded-full text-sm">
            Demo Mode
          </span>
        ) : user ? (
          <div className="flex items-center gap-3">
            {user.photoURL && (
              <img
                src={user.photoURL}
                alt={user.displayName || "User"}
                className="w-8 h-8 rounded-full"
              />
            )}
            <span className="text-gray-300 text-sm hidden md:inline">
              {user.displayName || user.email}
            </span>
          </div>
        ) : null}

        <button
          onClick={logout}
          className="bg-gray-700 hover:bg-gray-600 text-white font-medium px-4 py-2 rounded-lg transition-colors text-sm"
        >
          Logout
        </button>
      </div>
    </header>
  );
}
